import { OptionContainer, OptionLine, OptionTitle } from "./SelectOptionStyles";
import React from "react";
import { InventoryBin } from "../internal/parts/Bins/inventoryBinTypes";

export default function BinOption({
  bin,
  selected,
}: {
  bin: InventoryBin;
  selected: boolean;
}) {
  return (
    <OptionContainer selected={selected}>
      <OptionLine>
        <OptionTitle selected={selected}>{bin.bin_name}</OptionTitle>
      </OptionLine>
      <OptionLine>
        <div>{bin.flashpcb_bin_barcode}</div>
      </OptionLine>
    </OptionContainer>
  );
}
